<mat-card>
    <mat-card-content>
        <div fxLayout="column">
            <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
                <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
                    <div fxLayout="row wrap" fxLayoutGap="8px" fxLayoutAlign="start center">
                        <strong class="noMarginHeader">Results ({{ totalCount }})</strong>
                        &nbsp;&nbsp;

                        <mat-form-field style="width:200px;">
                            <input matInput placeholder="Filter Results" [(ngModel)]="filterString" (keyup)="onFilterStringChanged()" />
                        </mat-form-field>

                        <mat-form-field style="width:120px;">
                            <mat-label>File Type</mat-label>
                            <mat-select multiple [formControl]="filterFileTypes" (selectionChange)="search(true)">
                                <mat-option *ngFor="let fileType of fileTypeOptions" [value]="fileType">{{ fileType }}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field style="width:130px;">
                            <mat-label>Uploaded From</mat-label>
                            <input matInput [matDatepicker]="startPicker" [(ngModel)]="filterStartDate" (dateChange)="search(true)" />
                            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                            <mat-datepicker #startPicker></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field style="width:130px;">
                            <mat-label>Uploaded To</mat-label>
                            <input matInput [matDatepicker]="endPicker" [(ngModel)]="filterEndDate" (dateChange)="search(true)" />
                            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                            <mat-datepicker #endPicker></mat-datepicker>
                        </mat-form-field>

                        <button mat-raised-button (click)="resetFilters()">Reset Filters</button>
                    </div>

                    <div fxLayoutGap="8px" fxLayoutAlign="center center">
                        <input type="file" [id]="fileInputId" [accept]="acceptedFileExtensions" (change)="onFileSelected($event)" style="display: none;">
                        <button mat-raised-button color="primary" [disabled]="uploading || entityId === 0" (click)="triggerFileInput()">
                            <mat-icon>upload_file</mat-icon>
                            {{ uploading ? 'Uploading...' : 'Add Document' }}
                        </button>
                    </div>
                </div>
                <div style="text-align: right; color: #666; font-size: 12px; margin-top: 4px;">
                    Accepted file types: {{ acceptedFileTypes }}
                </div>

                <br />

                <div *ngIf="loading" style="display: flex; justify-content: center; padding: 40px;">
                    <mat-spinner></mat-spinner>
                </div>

                <div *ngIf="!loading && documents.length === 0" style="text-align: center; padding: 40px; color: grey;">
                    <mat-icon style="font-size: 48px; width: 48px; height: 48px;">folder_open</mat-icon>
                    <p>No documents found for this {{ entityLabel }}.</p>
                    <p>Documents on applications that are not yet linked to this record will not appear here.</p>
                </div>

                <mat-table *ngIf="!loading && documents.length > 0" [dataSource]="documents" matSort #TableSort="matSort"
                           [matSortActive]="sortBy" [matSortDirection]="sortDirection" (matSortChange)="onSortChanged($event)"
                           class="mat-elevation-z8" style="overflow-x: auto;">
                    <mat-header-row fxLayout="row" fxLayout.lt-md="column" *matHeaderRowDef="tableColumns"></mat-header-row>
                    <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; columns: tableColumns"
                             [ngStyle]="{'--hover-bg-color': sharedService.hoverBackgroundColor}"></mat-row>

                    <ng-container *ngFor="let cellData of tableFormat" [matColumnDef]="cellData.columnName">
                        <mat-header-cell [mat-sort-header]="cellData.columnName" [disabled]="!cellData.sortable"
                                         [fxFlex]="cellData.size" *matHeaderCellDef>{{ cellData.displayName }}</mat-header-cell>
                        <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" matTooltip="{{ row[cellData.columnName] }}">
                            <ng-container [ngSwitch]="cellData.type">
                                <ng-container *ngSwitchCase="'date'">
                                    {{ row[cellData.columnName] | date:'MM/dd/yyyy' }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'size'">
                                    {{ formatFileSize(row[cellData.columnName]) }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'link'">
                                    <a *ngIf="canOpenOwner(row)" class="owner-link" (click)="openOwner(row); $event.stopPropagation()">{{ row.ownerDisplayName }}</a>
                                    <span *ngIf="!canOpenOwner(row)">{{ row.ownerDisplayName }}</span>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <span>{{ row[cellData.columnName] }}</span>
                                </ng-container>
                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef fxFlex="10">Actions</mat-header-cell>
                        <mat-cell *matCellDef="let row" fxFlex="10">
                            <button mat-icon-button color="primary" (click)="downloadFile(row); $event.stopPropagation()" matTooltip="Download">
                                <mat-icon>download</mat-icon>
                            </button>
                            <button mat-icon-button color="warn" (click)="deleteFile(row); $event.stopPropagation()" matTooltip="Delete">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>
                </mat-table>

                <br />
                <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="pageIndex"
                               [pageSizeOptions]="[5, 10, 25, 50, 100]" (page)="onPageChanged($event)"
                               showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </mat-card-content>
</mat-card>
